import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {ChangeOwnPasswordContent} from "./payloads/change-own-password-content";

/**
 * Action command (ADR-015/016): the logged-in user sets a new password for their own account (settings
 * page "Mein Profil", section "Passwort ändern"). `mainEntityClass` is `'user'`, `mainEntityUid` the
 * user's own uid; the backend refuses any other uid and needs the current password. On success every
 * other login of the user ends; this tab's own login continues with the cookie of the response.
 *
 * No transformer (ADR-016): the payload is a `CommandPayload`, serialized by the generic path in
 * `TransformerHelper`.
 */
export class ChangeOwnPasswordCommand extends AbstractCommand<ChangeOwnPasswordContent> {

    public name: CommandName = CommandName.CHANGE_OWN_PASSWORD;

    public tags = ['own-profile', 'change'];

    constructor(userUid: string, content: ChangeOwnPasswordContent) {
        super('user', userUid, content);
    }
}
